"use strict";

var _regeneratorRuntime = require("/tmp/github-runner/alinewines/alinewines/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createClass = require("/tmp/github-runner/alinewines/alinewines/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/tmp/github-runner/alinewines/alinewines/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Controller = exports.HTTPError = void 0;

var Redux = require("redux");

var HTTPError = function HTTPError(code) {
  _classCallCheck(this, HTTPError);

  this.code = code;
};

exports.HTTPError = HTTPError;

var Controller = /*#__PURE__*/function () {
  /**
   * @param id is the key that the controller manage in the state
   * @param defaultState default value of the state
   */
  function Controller(id) {
    var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Controller);

    this.defaultState = {};
    this._init = false;
    this._initPromises = [];
    this.id = id;
    this.defaultState = Object.assign({
      _async: {}
    }, defaultState);
    Controller.controllers[id] = this;
  }
  /**
   * Set the status of the controller to initialized, resolve any promise on waitInit()
   */


  _createClass(Controller, [{
    key: "setInitialized",
    value: function setInitialized() {
      this._init = true;

      this._initPromises.forEach(function (res) {
        return res();
      });
    }
    /**
     * Wait for the controller to be initialized
     */

  }, {
    key: "waitInit",
    value: function waitInit() {
      var _this = this;

      if (this._init) {
        return;
      }

      return new Promise(function (resolve) {
        _this._initPromises.push(resolve);
      });
    }
    /**
     * @param id get controller singleton
     */

  }, {
    key: "getReducer",

    /**
     * Get Reducer
     */
    value: function getReducer() {
      return this.reduce.bind(this);
    }
    /**
     * Retrieve the all Redux state
     */

  }, {
    key: "getState",
    value: function getState() {
      return Controller.store.getState();
    }
    /**
     * Retrieve the Redux state manage by this controller
     */

  }, {
    key: "getLocalState",
    value: function getLocalState() {
      return Controller.store.getState()[this.id];
    }
    /**
     * Return controller id
     */

  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
    /**
     * Redux store to manage
     * @param store
     */

  }, {
    key: "getPersistanceConfiguration",

    /**
     * Prevent to store the _async information
     * @param storage
     */
    value: function getPersistanceConfiguration(storage) {
      return {
        key: this.id,
        storage: storage,
        blacklist: ["_async"]
      };
    }
    /**
     * Init the controller
     *
     * Registering the listeners
     */

  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter(function (prop) {
        return prop.startsWith("after");
      }).forEach(function (name) {
        _this2.addListener(name, _this2);
      });
      return true;
    }
    /**
     *
     * @param name
     * @param controller
     */

  }, {
    key: "addListener",
    value: function addListener(name, controller) {
      if (!Controller.hasListener) {
        Controller.getStore().subscribe(Controller._actionListener);
        Controller.hasListener = true;
      }

      if (!Controller.listenersMap[name]) {
        Controller.listenersMap[name] = [this];
      } else {
        Controller.listenersMap[name].push(this);
      }
    }
    /**
     *
     * @param args
     */

  }, {
    key: "reduce",

    /**
     *
     * @param state
     * @param action
     */
    value: function reduce(state, action) {
      if (!state) {
        return this.defaultState;
      }

      Controller.lastAction = action;

      if (typeof this["on" + action.type] === "function") {
        var res = this["on" + action.type](state, action);

        if (!res) {
          return state;
        }

        return res;
      }

      return state;
    }
    /**
     * Dispatch an action to Redux Store
     *
     * @param action
     */

  }, {
    key: "getRequestActionName",

    /**
     * When asyncAction is used
     *
     * The first action sent is this one
     * @param name
     */
    value: function getRequestActionName(name) {
      return name + "";
    }
    /**
     * When asyncAction is used, if successull
     *
     * The action sent when async action is successfull
     * @param name
     */

  }, {
    key: "getSuccessActionName",
    value: function getSuccessActionName(name) {
      return name + "_SUCCESS";
    }
    /**
     * When asyncAction is used, if failed
     *
     * The action sent when async action is in error
     * @param name
     */

  }, {
    key: "getErrorActionName",
    value: function getErrorActionName(name) {
      return name + "_FAILED";
    }
    /**
     * Launch an async action
     *
     * By default, if name is GET_USER it will send an action with
     *  - GET_USER
     *  - GET_USER_SUCCESS -> if success
     *  - GET_USER_FAILED -> if error
     *
     * The Redux state will contain a
     * _async: {
     *  GET_USER: {
     *   syncing: true|false,
     *   error: undefined|HTTPError
     *  }
     * }
     * @param name of the action like GET_USER
     * @param action any additional informations you want to pass
     * @param postActions callback to execute after the action
     * @param postFailures callback to execute after the action failed
     */

  }, {
    key: "asyncAction",
    value: function asyncAction(name, action) {
      var _this3 = this;

      var postActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var postFailures = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      Controller.dispatch(function (dispatch, getState) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var requestName, successName, result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  requestName = this.getRequestActionName(name);

                  if (!this["on" + requestName]) {
                    this["on" + requestName] = function (state) {
                      var obj = Object.assign({}, state);
                      obj._async = obj._async || {};
                      obj._async[requestName] = {
                        syncing: true
                      };
                      return obj;
                    };
                  }

                  dispatch({
                    type: requestName,
                    asyncStart: true
                  });
                  _context.prev = 3;
                  successName = this.getSuccessActionName(name);
                  _context.next = 7;
                  return action(dispatch, getState);

                case 7:
                  result = _context.sent;

                  if (!this["on" + successName]) {
                    this["on" + successName] = function (state, actionInfo) {
                      var obj = Object.assign(Object.assign({}, state), actionInfo.result);
                      obj._async = obj._async || {};
                      obj._async[requestName] = {
                        syncing: false
                      };
                      return obj;
                    };
                  }

                  dispatch({
                    type: successName,
                    asyncEnd: true,
                    result: result
                  });
                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](3);
                  this.onAsyncActionError(name, requestName, dispatch, postFailures, _context.t0);

                case 15:
                  if (postActions) {
                    postActions(dispatch, getState);
                  }

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 12]]);
        }));
      });
    }
    /**
     *
     * @param name of the action
     * @param requestName request name stored in async
     * @param dispatch dispatch function
     * @param postFailures callback to execute after the action failed
     * @param err error that occured
     */

  }, {
    key: "onAsyncActionError",
    value: function onAsyncActionError(name, requestName, dispatch, postFailures, err) {
      var errorName = this.getErrorActionName(name);

      if (!this["on" + errorName]) {
        this["on" + errorName] = function (state, actionInfo) {
          var obj = Object.assign({}, state);
          obj._async = obj._async || {};
          obj._async[requestName] = {
            syncing: false,
            error: actionInfo.error
          };
          return obj;
        };
      }

      dispatch({
        type: errorName,
        asyncEnd: true,
        error: err
      });

      if (postFailures) {
        postFailures(err);
      }

      return;
    }
    /**
     *
     * @param url path
     * @param method GET|POST|PUT|PATCH
     * @param body to send
     * @param options options to pass to fetch
     * @param endpoint
     */

  }, {
    key: "ajax",
    value: function ajax(url) {
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GET";
      var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        credentials: "include",
        headers: {}
      };
      var endpoint = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Controller.endpoint;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var finalUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options.body = options.raw ? body : JSON.stringify(body);
                options.headers = Object.assign({
                  "content-type": options.headers && options.headers["content-type"] ? options.headers["content-type"] : "application/json"
                }, options.headers);
                options.method = method;
                finalUrl = url; // If url are not absolute, append the endpoint

                if (!finalUrl.startsWith("https://") && !finalUrl.startsWith("http://")) {
                  finalUrl = endpoint + url;
                }

                _context2.t0 = this;
                _context2.next = 8;
                return fetch(finalUrl, options);

              case 8:
                _context2.t1 = _context2.sent;
                _context2.t2 = Object.assign({
                  url: endpoint + url
                }, options);
                return _context2.abrupt("return", _context2.t0.processResponse.call(_context2.t0, _context2.t1, _context2.t2));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Return an absolute url from relative path
     * @param path
     */

  }, {
    key: "processResponse",

    /**
     * Parse response
     * @param response to parse
     */
    value: function processResponse(response, request) {
      if (response.status >= 400) {
        throw new HTTPError(response.status);
      }

      if (response.status === 204) {
        return {};
      }

      if (response.status === 200 && response.headers.get("content-type") === "application/json") {
        return response.json();
      }

      return response;
    }
  }], [{
    key: "get",
    value: function get(id) {
      return Controller.controllers[id];
    }
    /**
     *
     * @param url of the default api endpoint
     */

  }, {
    key: "setEndpoint",
    value: function setEndpoint(url) {
      Controller.endpoint = url;
    }
  }, {
    key: "setStore",
    value: function setStore(store) {
      Controller.store = store;

      for (var i in Controller.controllers) {
        if (Controller.controllers[i].init()) {
          Controller.controllers[i].setInitialized();
        }
      }
    }
    /**
     * Retrieve Redux Store
     */

  }, {
    key: "getStore",
    value: function getStore() {
      return Controller.store;
    }
    /**
     * Get all reduucers
     */

  }, {
    key: "getReducers",
    value: function getReducers() {
      var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var mapper = {};

      for (var i in Controller.controllers) {
        // Allow persistance layer
        if (persist && Controller.controllers[i].getPersistanceConfiguration(storage)) {
          mapper[Controller.controllers[i].getId()] = persist(Controller.controllers[i].getPersistanceConfiguration(storage), Controller.controllers[i].getReducer());
        } else {
          mapper[Controller.controllers[i].getId()] = Controller.controllers[i].getReducer();
        }
      }

      return Redux.combineReducers(mapper);
    }
  }, {
    key: "_actionListener",
    value: function _actionListener() {
      var key = "after" + Controller.lastAction.type;

      if (!Controller.listenersMap[key]) {
        return;
      }

      Controller.listenersMap[key].forEach(function (controller) {
        controller[key](Controller.lastAction);
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      Controller.store.dispatch(action);
    }
  }, {
    key: "getUrl",
    value: function getUrl(path) {
      return Controller.endpoint + path;
    }
  }]);

  return Controller;
}();

exports.default = Controller;
exports.Controller = Controller;
Controller.controllers = new Map();
Controller.hasListener = false;
Controller.listenersMap = new Map();